/**
 * The column-level sentinel stored inside `visibilityTypes`: it means "never
 * show this column, in any non-internal view", and it outranks every view id
 * sitting beside it. Read by `filterVisibleColumns`, the two XLSX producers,
 * the clipboard and keyboard navigation — and, on this branch, by
 * `resolveVisibilityCellState` and `ViewVisibilityControl` so the editors
 * cannot paint a column as shown that no renderer will ever draw.
 * It is not a `VisibilityType`: no org list defines it, so no pool ever
 * contains it and no surface can author or clear it. Every write path must
 * therefore carry it through untouched.
 */
export const hiddenColumnSentinel = 'hidden';
